import { render, staticRenderFns } from "./studentExam.vue?vue&type=template&id=2b1bc572&scoped=true&"
import script from "./studentExam.vue?vue&type=script&lang=js&"
export * from "./studentExam.vue?vue&type=script&lang=js&"
import style0 from "./studentExam.vue?vue&type=style&index=0&id=2b1bc572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1bc572",
  null
  
)

export default component.exports